import { render, staticRenderFns } from "./PeerGroupListCreator.vue?vue&type=template&id=7bb07762&"
import script from "./PeerGroupListCreator.vue?vue&type=script&lang=ts&"
export * from "./PeerGroupListCreator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports